import { createContext } from 'react';

const departmentContext = createContext();

export default departmentContext;
